import { useContext } from 'react';
import { LayoutContext } from '../contexts/LayoutContext';

export function useShellLayout() {
  return useContext(LayoutContext);
}
